import WellList from './WellList';

export default WellList;



// WEBPACK FOOTER //
// ./src/Components/Main/WellList/index.tsx